import React from 'react';
import { Box, Group, Tabs as MantineTabs } from '@mantine/core';
import { Tab, TabsList, TabsListActions } from './components';

export const TabsContext = React.createContext<string | null>(null);

type TabsPropsType<T extends string> = {
  children: React.ReactNode;
  value: T;
  onChange?: (value: T | null) => void;
};

const TabsRoot = <T extends string>({
  children,
  value,
  onChange = () => {},
}: TabsPropsType<T>) => {
  return (
    <TabsContext.Provider value={value}>
      <Box flex="1">
        <Group justify="between">
          <MantineTabs
            color="blue"
            flex="1"
            mt="4px"
            value={value}
            onChange={(newValue) => onChange(newValue as T)}
          >
            {children}
          </MantineTabs>
        </Group>
      </Box>
    </TabsContext.Provider>
  );
};

export const Tabs = Object.assign(TabsRoot, {
  TabsList,
  TabsListActions,
  TabsPanel: MantineTabs.Panel,
  Tab,
});
